import { render, staticRenderFns } from "./BlockedApplicant.vue?vue&type=template&id=5b46e419&lang=html&"
import script from "./BlockedApplicant.vue?vue&type=script&lang=js&"
export * from "./BlockedApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports